const NEWLINE_REGEX = /\n/g;

function findWithRegex(regex, contentBlock, callback) {
  const text = contentBlock.getText();
  let matchArr, start;
  while ((matchArr = regex.exec(text)) !== null) {
    start = matchArr.index;
    callback(start, start + matchArr[0].length);
  }
}

function strategy(contentBlock, callback, contentState) {
  findWithRegex(NEWLINE_REGEX, contentBlock, callback);
}

const component = (props) => {
  return <br key={`newline-${props.offsetKey}`} />;
};

export const NewLineDecorator = {
  strategy,
  component,
};
